<template>
  <q-select
    filled
    :model-value="model"
    use-input
    fill-input
    emit-value
    map-options
    stack-label
    hide-selected
    input-debounce="0"
    :options="options"
    :loading="loading"
    option-label="name"
    option-value="id"
    hint="Danisan ismi ile arama yapabilirsiniz."
    @filter="filterFn"
    @input-value="onCustomerSelect"
  >
  </q-select>
</template>
<script>
import axios from 'axios'
import { ref } from 'vue'
import { useRouter } from 'vue-router'

export default {
  setup() {
    const router = useRouter()
    const loading = ref(false)
    const model = ref(null)
    const options = ref([])

    return {
      loading,
      model,
      options,

      filterFn(val, update) {
        update(() => {
          if (val.length > 2) {
            loading.value = true
            options.value.length = 0
            axios
              .get(`/customers/search?name=${val}`)
              .then((response) => {
                options.value = response.data
              })
              .finally(() => {
                loading.value = false
              })
          }
        })
      },

      // if text is in the options, it is selected ?
      onCustomerSelect(text) {
        options.value.forEach((customer) => {
          if (customer.name === text) {
            router.push('/customer/' + customer.id)
          }
        })
      },
    }
  },
}
</script>
